import type { FormikValues } from 'formik';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';

import { FormModal } from '../../../../../components/Formik';
import { createProductType } from '../../../../../redux/safescarf/productTypes/actions';

export interface CreateProductTypeFormModalProps {
  onSubmit: () => void;
  onCancel: () => void;
}

const CreateProductTypeFormModal: React.FC<CreateProductTypeFormModalProps> = ({
  onSubmit,
  onCancel,
}) => {
  const dispatch = useDispatch();

  const fields = [
    {
      fieldType: 'text',
      name: 'name',
      label: 'Name',
    },
    {
      fieldType: 'text',
      name: 'description',
      label: 'Description',
    },
  ];

  const initialValues = {
    name: '',
    description: '',
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Required'),
    description: Yup.string().required('Required'),
  });

  const handleSubmit = (formValues: FormikValues): void => {
    onSubmit();
    dispatch(createProductType({ ...formValues }));
  };

  return (
    <FormModal
      title='Create New Product Type'
      fields={fields}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      submitLabel='Create'
    />
  );
};

export default CreateProductTypeFormModal;
